if (!customElements.get('delivery-delay')) {
    customElements.define('delivery-delay', class DeliveryDelay extends HTMLElement {
      constructor() {
        super();

        this.variantsDelays = this.querySelectorAll(".product-delivery-delay-item");
        this.showDeliveryDelayForVariant(this.dataset.variantId);
      }
  
      showDeliveryDelayForVariant(variantId) {
        for (const variant of this.variantsDelays) {
            if (parseInt(variant.dataset.variantId) === parseInt(variantId)) {
                variant.style.display = 'block';
            } else {
                variant.style.display = 'none';
            }
        }
      }
  })
}
